import { Flex, Box } from '@vibe/core';

type ErrorBoxProps = {
  message: string;
};

function ErrorBox({ message }: ErrorBoxProps) {
  return (
    <div
      style={{
        backgroundColor: '#d83a52',
        color: '#ffffff',
      }}
    >
      <Box padding="large" paddingStart="xl" paddingEnd="xl">
        <Flex gap="medium" align="center" justify="center">
          <div
            style={{
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
            }}
          >
            Oops, something went wrong: {message}
          </div>
        </Flex>
      </Box>
    </div>
  );
}

export default ErrorBox;
